export default __webpack_public_path__ + "9588fd1904dcdac1b0ed717da34b6ed5.png";